import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import InputField from "components/fields/InputField";
import CustomButton from "components/button/custom_button";
import Checkbox from "components/checkbox";
import Modal from "components/modal";
import Select from "components/select";
import Radio from "components/radio";
import Loader from "components/loader";
import Alert from "components/alert";
import { MdFileUpload, MdDelete, MdLockReset } from "react-icons/md";
import ApiList from "services/apiList";
import {
  fetchSelectedUser,
  fetchTeacherTypes,
  fetchPositions,
  fetchCources,
  fetchAllUserCount,
  setCourse,
  setGender,
  setType,
  setPosition,
  setMrole,
  setSrole,
  setTrole,
  setFrole,
  setChrole,
  setProle,
  setFileName,
  setUsername,
  setLastname,
  setFirstname,
  setPassword,
  setRegister,
  setPhone,
  setEmail,
} from "services/users/userAddEditSlice";
import Card from "components/card";
import { setUserCode } from "services/users/userAddEditSlice";
import { setInitialSate } from "services/users/userAddEditSlice";
import { setDefaultInitialState } from "services/users/userAddEditSlice";
import { fetchSelectedUserCourse } from "services/users/userAddEditSlice";
import { setTeacherTimeLimit } from "services/users/userAddEditSlice";
import { deleteUser } from "services/users/userAddEditSlice";
import { addUser } from "services/users/userAddEditSlice";
import axios from "axios";
import PasswordChangeModal from "../profile/components/modal/PasswordChangeModal";
const UserDetail = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [image, setImage] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showPasswordChangeModal, setShowPasswordChangeModal] = useState(false);

  const dispatch = useDispatch();
  const addEdit = useSelector((state) => {
    return state.userAddEdit;
  });

  useEffect(() => {
    if (id) {
      dispatch(fetchSelectedUser(id)).then((response) => {
        dispatch(setInitialSate());
        dispatch(fetchSelectedUserCourse(id));
      });
    } else {
      dispatch(setDefaultInitialState());
      dispatch(fetchAllUserCount()).then((response) => {
        dispatch(setUserCode());
      });
    }
    dispatch(fetchTeacherTypes());
    dispatch(fetchPositions());
    dispatch(fetchCources());
  }, [dispatch, id]);

  return (
    <Card extra={"mt-4 w-full bg-white p-5 pb-8"}>
      {addEdit.loading && <Loader />}
      {!addEdit.loading && addEdit.error ? (
        <Alert text={addEdit.error} />
      ) : null}
      {!addEdit.loading &&
      addEdit.teacherTypes.length &&
      addEdit.positions.length ? (
        <div>
          <header className="relative flex items-center justify-end pb-2 pt-4 lg:pr-20">
            <button
              className={`mr-6 rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10 ${
                id ? "block" : "pt-30 hidden"
              }`}
              onClick={() => {
                setShowPasswordChangeModal(true);
              }}
            >
              <MdLockReset className="fill-bg-btn-1 m  h-6 w-6" />
            </button>
            <button
              className={`rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10  ${
                id ? "block" : "pt-30 hidden"
              }`}
              onClick={() => setShowModal(true)}
            >
              <MdDelete className="h-6 w-6 fill-red-600" />
            </button>
          </header>

          <div className=" justify-start gap-5 lg:flex">
            <div className="h-full w-full rounded-xl bg-lightPrimary lg:h-96 lg:w-96 2xl:col-span-6 dark:!bg-navy-700">
              <button
                className="flex h-full w-full flex-col items-center justify-center rounded-xl border-[2px] border-dashed border-btn-2 p-1  dark:!border-navy-700"
                onClick={() => {
                  document.querySelector(".input-file-field").click();
                }}
              >
                <input
                  type="file"
                  accept="image/*"
                  className="input-file-field"
                  onChange={({ target: { files } }) => {
                    files[0] && dispatch(setFileName(files[0].name));
                    if (files) {
                      setImage(files[0]);
                    }
                  }}
                  hidden
                />
                {image ? (
                  <img
                    src={URL.createObjectURL(image)}
                    alt={addEdit.form.fileName}
                    className="h-full w-full border-[2px] object-cover"
                  />
                ) : addEdit.form.fileName ? (
                  <img
                    src={addEdit.form.fileName}
                    alt={addEdit.form.fileName}
                    className="h-full w-full border-[2px] object-cover"
                  />
                ) : (
                  <div className="grid grid-rows-1 place-items-center ">
                    <MdFileUpload className="text-[80px] text-brand-500 dark:text-white" />
                    <h4 className="text-xl font-bold text-brand-500 dark:text-white">
                      Upload File
                    </h4>
                    <p className="mt-2 text-sm font-medium text-gray-600">
                      PNG, JPG and GIF files are allowed
                    </p>
                  </div>
                )}
              </button>
            </div>
            <form
              onSubmit={(e) => {
                if (!e.preventDefault()) {
                  dispatch(addUser(id)).then((response) => {
                    if (response.payload) {
                      if (response.payload.status) {
                        if (response.payload.result) {
                          if (response.payload.result.id) {
                            if (image !== undefined && image !== null) {
                              const formData = new FormData();
                              formData.append("id", response.payload.result.id);
                              formData.append("image", image);
                              try {
                                axios.post(ApiList.uploadProfileUrl, formData, {
                                  headers: {
                                    "Content-Type": "multipart/form-data",
                                  },
                                });
                              } catch (error) {}
                            }
                          }
                        }
                      }
                      navigate("/admin/users");
                    }
                  });
                }
              }}
            >
              {/* USER INPUTS  */}
              <InputField
                className="lg:w-96"
                key={"user_detail" + 1}
                id={"ud_id" + 1}
                value={addEdit.form.username || ""}
                type="text"
                placeholder="e.g. manager"
                disabled={true}
                errorMessage="Хэрэглэгчийн нэр 3-16 тэмдэгтээс бүрдэх бөгөөд ямар нэгэн тусгай тэмдэгт оруулах ёсгүй!"
                label="Хэрэглэгчийн нэр"
                pattern="^[A-Za-z0-9]{3,16}$"
                required={true}
                onChange={(e) => dispatch(setUsername(e.target.value))}
              />

              <InputField
                className="lg:w-96"
                key={"user_detail" + 2}
                id={"ud_id" + 2}
                value={addEdit.form.lastname || ""}
                type="text"
                placeholder="Овог"
                errorMessage="Овог 3-16 тэмдэгтээс бүрдэх бөгөөд ямар нэгэн тусгай тэмдэгт оруулах ёсгүй!"
                label="Овог"
                pattern="^[QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnmабвгдеёжзийклмноөпрстуүфхцчшщъыьэюяАБВГДЕЁЖЗИЙКЛМНОӨПРСТУҮФХЦЧШЩЪЫЬЭЮЯ]{3,16}$"
                required={true}
                onChange={(e) => dispatch(setLastname(e.target.value))}
              />

              <InputField
                className="lg:w-96"
                key={"user_detail" + 3}
                id={"ud_id" + 3}
                value={addEdit.form.firstname || ""}
                type="text"
                placeholder="Нэр"
                errorMessage="Нэр 3-16 тэмдэгтээс бүрдэх бөгөөд ямар нэгэн тусгай тэмдэгт оруулах ёсгүй!"
                label="Нэр"
                pattern="^[QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnmабвгдеёжзийклмноөпрстуүфхцчшщъыьэюяАБВГДЕЁЖЗИЙКЛМНОӨПРСТУҮФХЦЧШЩЪЫЬЭЮЯ]{3,16}$"
                required={true}
                onChange={(e) => dispatch(setFirstname(e.target.value))}
              />

              {id ? null : (
                <InputField
                  className="lg:w-96"
                  key={"user_detail" + 4}
                  id={"ud_id" + 4}
                  value={addEdit.form.password || ""}
                  type="password"
                  placeholder="Нууц үг"
                  errorMessage="Нууц үгээ оруулна уу! 5-аас дээш тэмдэгт байх ёстой."
                  label="Нууц үг"
                  pattern="^.{5,10}$"
                  required={true}
                  onChange={(e) => dispatch(setPassword(e.target.value))}
                />
              )}

              <InputField
                className="lg:w-96"
                key={"user_detail" + 5}
                id={"ud_id" + 5}
                value={addEdit.form.register || ""}
                type="text"
                placeholder="Регистр"
                errorMessage="Регистрийн дугаарыг кирилл үсгээр оруулна уу!"
                label="Регистр"
                pattern="^[абвгдеёжзийклмноөпрстуүфхцчшщъыьэюяАБВГДЕЁЖЗИЙКЛМНОӨПРСТУҮФХЦЧШЩЪЫЬЭЮЯ]{2}[0-9]{8}$"
                required={false}
                onChange={(e) => dispatch(setRegister(e.target.value))}
              />

              <InputField
                className="lg:w-96"
                key={"user_detail" + 6}
                id={"ud_id" + 6}
                value={addEdit.form.phone || ""}
                type="text"
                placeholder="Утас"
                errorMessage="Утасны дугаар оруулна уу!"
                label="Утас"
                pattern="^[0-9]{8}$"
                required={false}
                onChange={(e) => dispatch(setPhone(e.target.value))}
              />

              <InputField
                className="lg:w-96"
                key={"user_detail" + 7}
                id={"ud_id" + 7}
                value={addEdit.form.email || ""}
                type="text"
                placeholder="Имэйл"
                errorMessage="Имэйл хаяг зөв оруулна уу!"
                label="Имэйл"
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                required={false}
                onChange={(e) => dispatch(setEmail(e.target.value))}
              />

              <div className="mt-5 flex gap-4 ">
                <Radio
                  value={addEdit.form.gender}
                  onChange={(e) => dispatch(setGender(true))}
                  checked={(addEdit.form.gender || false) === true}
                  key="male"
                  name="gender"
                  color="bg-btn-1"
                  label="Эрэгтэй"
                />{" "}
                <Radio
                  value={addEdit.form.gender}
                  onChange={(e) => dispatch(setGender(false))}
                  checked={(addEdit.form.gender || false) === false}
                  key="female"
                  name="gender"
                  color="bg-btn-1"
                  label="Эмэгтэй"
                />
              </div>
              <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-3 ">
                <Checkbox
                  key={"manager"}
                  label="Менежер"
                  value={addEdit.form.mRole}
                  onChange={() => {
                    dispatch(setMrole(!addEdit.form.mRole));
                    if (!id) {
                      dispatch(setUserCode());
                    }
                  }}
                />
                <Checkbox
                  key={"teacher"}
                  label="Багш"
                  value={addEdit.form.tRole}
                  onChange={() => {
                    dispatch(setTrole(!addEdit.form.tRole));
                    if (!id) {
                      dispatch(setUserCode());
                    }
                  }}
                />
                <Checkbox
                  key={"student"}
                  label="Сурагч"
                  value={addEdit.form.sRole}
                  onChange={() => {
                    dispatch(setSrole(!addEdit.form.sRole));
                    if (!id) {
                      dispatch(setUserCode());
                    }
                  }}
                />
              </div>
              <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-3 ">
                <Checkbox
                  key={"chef"}
                  label="Тогооч"
                  value={addEdit.form.chRole}
                  onChange={() => {
                    dispatch(setChrole(!addEdit.form.chRole));
                    if (!id) {
                      dispatch(setUserCode());
                    }
                  }}
                />
                <Checkbox
                  key={"food_technologist"}
                  label="Хоол технологич"
                  value={addEdit.form.fRole}
                  onChange={() => {
                    dispatch(setFrole(!addEdit.form.fRole));
                    if (!id) {
                      dispatch(setUserCode());
                    }
                  }}
                />

                <Checkbox
                  key={"parent"}
                  label="Асран хамгаалагч"
                  value={addEdit.form.pRole}
                  onChange={() => {
                    dispatch(setProle(!addEdit.form.pRole));
                    if (!id) {
                      dispatch(setUserCode());
                    }
                  }}
                />
              </div>
              {addEdit.form.tRole ? (
                <div>
                  <InputField
                    key="teacherTimeLimit"
                    className="lg:w-96"
                    type="number"
                    label="Багшийн цагийн хязгаар (7 хоногт)"
                    errorMessage="Багшийн цагийн хязгаар оруулна уу"
                    value={addEdit.form.teacherTimeLimit || ""}
                    onChange={(e) =>
                      dispatch(setTeacherTimeLimit(e.target.value))
                    }
                  />

                  <Select
                    id="teacherType"
                    value={addEdit.form.teacher_type}
                    required={true}
                    label="Заах аргын нэгдэл"
                    defaultText="Заах аргын нэгдэл сонгоно уу."
                    onChange={(selected) => {
                      dispatch(setType(selected.target.value));
                    }}
                    children={addEdit.teacherTypes.map((row, index) => {
                      return (
                        <option key={"Option" + index} value={row.id}>
                          {row.name}
                        </option>
                      );
                    })}
                  />
                </div>
              ) : (
                <></>
              )}
              {addEdit.form.mRole ? (
                <Select
                  id="position"
                  value={addEdit.form.position}
                  required={true}
                  label="Албан тушаал"
                  defaultText="Албан тушаал сонгоно уу."
                  onChange={(selected) => {
                    dispatch(setPosition(selected.target.value));
                  }}
                  children={addEdit.positions.map((row, index) => {
                    return (
                      <option key={"position" + index} value={row.id}>
                        {row.name}
                      </option>
                    );
                  })}
                />
              ) : (
                <></>
              )}

              {addEdit.form.sRole ? (
                <Select
                  id="studentCourses"
                  value={addEdit.form.course}
                  required={true}
                  label="Анги"
                  defaultText="Анги сонгоно уу."
                  onChange={(selected) => {
                    dispatch(setCourse(selected.target.value));
                  }}
                  children={addEdit.courses.map((row, index) => {
                    return (
                      <option key={"course" + index} value={row.id}>
                        {row.number}
                        {row.group}
                      </option>
                    );
                  })}
                />
              ) : (
                <></>
              )}

              <CustomButton text="Хадгалах" type="submit" className="mr-3" />
              <CustomButton
                onClick={() => {
                  navigate("/admin/users");
                }}
                text="Буцах"
                isBack={true}
              />

              {showModal ? (
                <Modal
                  handleSubmit={() => {
                    dispatch(deleteUser(id)).then((response) => {
                      if (response.payload) {
                        if (response.payload.status) {
                          navigate("/admin/users");
                        }
                      }
                    });
                  }}
                  setShowModal={setShowModal}
                  child={
                    <p className="text-xl text-navy-700 dark:text-white">
                      Та "{addEdit.form.username}" {addEdit.form.lastname}
                      {"  "}
                      {addEdit.form.firstname}-ыг устгахдаа итгэлтэй байна уу?
                      Дараахтай холбоотой бүх зүйл устаж болзошгүй
                    </p>
                  }
                  title="Устгах"
                />
              ) : null}
            </form>{" "}
            {showPasswordChangeModal ? (
              <PasswordChangeModal
                id={id}
                setShowModal={setShowPasswordChangeModal}
              />
            ) : null}
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </Card>
  );
};

export default UserDetail;
